import React from 'react';
import PropTypes from 'prop-types';

import CustomAmount from './CustomAmount';
import PredefinedAmounts from './PredefinedAmounts';

const GifCardAmount = ({
  gcAmount,
  onGcAmountChange,
  toggleCustomGc,
  customGcOpen,
  customGcAmount,
  onCustomGcChange,
  onCustomGcSubmit,
  predefinedAmounts,
  hasCustomGcAmount,
}) => (
  <div className="u-text-center layout layout--flush u--ml- large-and-up--ml">
    <PredefinedAmounts
      gcAmount={gcAmount}
      onGcAmountChange={onGcAmountChange}
      predefinedAmounts={predefinedAmounts}
    />
    <CustomAmount
      toggleCustomGc={toggleCustomGc}
      customGcOpen={customGcOpen}
      customGcAmount={customGcAmount}
      onCustomGcChange={onCustomGcChange}
      onCustomGcSubmit={onCustomGcSubmit}
      hasCustomGcAmount={hasCustomGcAmount}
    />
  </div>
);

GifCardAmount.propTypes = {
  gcAmount: PropTypes.number.isRequired,
  onGcAmountChange: PropTypes.func.isRequired,
  toggleCustomGc: PropTypes.func.isRequired,
  onCustomGcChange: PropTypes.func.isRequired,
  customGcOpen: PropTypes.bool.isRequired,
  onCustomGcSubmit: PropTypes.func.isRequired,
  customGcAmount: PropTypes.number.isRequired,
  predefinedAmounts: PropTypes.arrayOf(PropTypes.number).isRequired,
  hasCustomGcAmount: PropTypes.bool.isRequired,
};

export default GifCardAmount;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCardAmount/GiftCardAmount.jsx